import { get } from 'lodash';
import * as Yup from 'yup';

export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'name', headerName: 'Name', width: 200 },
  { field: 'address', headerName: 'Address', width: 200 },
  { field: 'city', headerName: 'City', width: 200 },
  { field: 'state', headerName: 'State', width: 200 },
  { field: 'country', headerName: 'Country', width: 200 },
  { field: 'postal_code', headerName: 'Postal Code', width: 200 },
  {
    field: 'contact_first_name',
    headerName: 'Contact First Name/State',
    width: 200,
  },
  {
    field: 'contact_last_name',
    headerName: 'Contact Last Name P Code',
    width: 200,
  },
  { field: 'contact_title', headerName: 'Contact Title', width: 200 },
  { field: 'contact_email', headerName: 'Contact Email', width: 200 },
  { field: 'contact_phone', headerName: 'Contact Phone', width: 200 },
];

export const suggestionPrimaryKey = 'name';
export const suggestionSecondaryKeys = [
  'address',
  'city',
  'state',
  'country',
  'postal_code',
  'contact_first_name',
  'contact_last_name',
  'contact_title',
  'contact_email',
  'contact_phone',
];

export const initialValues = (organization) => {
  const {
    contact_phone: contactPhone,
    acc_mgr: accountManagerId,
    contact_first_name: contactFirstName,
    contact_last_name: contactLastName,
    contact_title: contactTitle,
    contact_email: contactEmail,
  } = organization || {};

  return {
    name: get(organization, 'name', ''),
    shortName: get(organization, 'short_name', ''),
    contactFirstName: contactFirstName || '',
    contactLastName: contactLastName || '',
    contactTitle: contactTitle || '',
    contactEmail: contactEmail || '',
    contactPhone: contactPhone || '',
    address: get(organization, 'address', ''),
    city: get(organization, 'city', ''),
    state: get(organization, 'state', ''),
    postalCode: get(organization, 'postal_code', ''),
    country: get(organization, 'country', ''),
    billingId: get(organization, 'billing_id', ''),
    accountManagerId: accountManagerId || '',
  };
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('field is required'),
  shortName: Yup.string().required('field is required'),
  contactFirstName: Yup.string(),
  contactLastName: Yup.string(),
  contactTitle: Yup.string(),
  contactEmail: Yup.string(),
  contactPhone: Yup.string(),
  address: Yup.string().required('field is required'),
  city: Yup.string().required('field is required'),
  state: Yup.string().required('field is required'),
  postalCode: Yup.string().required('field is required'),
  country: Yup.string().required('field is required'),
  billingId: Yup.number().required('field is required'),
  accountManagerId: Yup.number(),
});
